// extracted by mini-css-extract-plugin
export var featuredResources = "FeaturedResources-module--featured-resources--2v7qI";
export var featuredResourcesSmall = "FeaturedResources-module--featured-resources-small--s9Wgp";
export var recentPostsWrapper = "FeaturedResources-module--recent-posts-wrapper--C19D2";